export default {
  parseFile: async (file) => {
    const text = await file.text()
    return JSON.parse(text)
  },
}
